// extracted by mini-css-extract-plugin
export default {"outerCard":"mu6EgcbekgvQbIfwYUI8","draggingCard":"qjZCCVRyhvQdr0UonQPZ"};